import Entity from './entity'

export default class SiteMessage extends Entity<string>{
    name: string;
    url: string;
    sortNo: number;  
    isShow:string; 
    creationTime:string;
}